const DocumentStatus = {
  ACTIVE: 'ACTIVE',
  PVSM_SUSPENDED: 'PVSM SUSPENDED',
  SUSPENDED: 'SUSPENDED',
  MERGED: 'MERGED',
  INACTIVE: 'INACTIVE',
  DECEASED: 'DECEASED',
  REGISTRATION_IN_ANALYSIS: 'REGISTRATION IN ANALYSIS',
  CANCELLED: 'CANCELLED',
  PRE_REGISTRATION: 'PRE REGISTRATION',
  PENDING_ENROLLMENT: 'PENDING ENROLLMENT',
  PRE_REGISTRATION_BANKS: 'PRE REGISTRATION BANKS',
  INCOMPL_REGISTRATION_PARTNER: 'INCOMPL. REGISTRATION PARTNER'
};

export const FIRST_ACCESS_STATUS = [
  DocumentStatus.INCOMPL_REGISTRATION_PARTNER,
  DocumentStatus.PENDING_ENROLLMENT,
  DocumentStatus.PRE_REGISTRATION_BANKS
];